import {
  Box,
  Input,
  Link,
  Paper,
  Table,
  TableCell,
  TableContainer,
  Button,
} from '@material-ui/core';
import React from 'react';
import KenDateTimePicker from '../../global_components/KenDateTimePicker';
import { facultyDropDown } from '../../Pages/AdminPortal/Exam/Invigilation/InvigilationAssign';
import KenSelect from '../../global_components/KenSelect';
import KenInputField from '../KenInputField';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
  error: {
    // color: '#F14B2D',

    background: 'rgba(241, 75, 45, 0.2)',
    // background: '#c12002',
    // background: '#EB5757',

    borderRadius: '25px',
    // border: '1px solid #c12002',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px  5px',
    color: '#c12002',
    height: '23px',
    width: '115px',

    '&:hover': {
      color: '#c12002',
      background: 'rgba(241, 75, 45, 0.2)',

      // color: '#c12002',
      // borderBottom: '#F14B2D',
    },
  },
  normal: {
    // color: '#505F79',
    color: '#02ab4a',

    background: 'rgba(138, 245, 196,0.4)',
    // background: '#27AE60',

    // background: '#02ab4a',

    borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    height: '23px',
    width: '115px',

    '&:hover': {
      background: 'rgba(138, 245, 196,0.4)',

      color: '#02ab4a',
      // border: '1px solid #02ab4a',
    },
  },
  medium: {
    color: '#f17100',
    background: 'rgba(255, 196, 10,0.2)',
    textDecoration: 'none',

    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px 5px',
    width: '115px',
    height: '23px',

    '&:hover': {
      background: 'rgba(255, 196, 10,0.2)',
      color: '#f17100',
    },
  },
}));
const KenGridEditableData = ({
  row,
  name,
  onChange,
  type,
  columns,
  rowName,
  dropdown,
  style,
}) => {
  const { isEditMode } = row;

  const classes = useStyles();

  console.log('row', row);
  const { eligibility_status, status, document_submitted } = row;

  console.log({ eligibility_statussssssssssss: eligibility_status });

  let classOfBtn;
  if (eligibility_status === 'At Risk') {
    classOfBtn = classes.medium;
  } else if (eligibility_status === 'Not eligible') {
    classOfBtn = classes.error;
  } else if (eligibility_status === 'Eligible') {
    classOfBtn = classes.normal;
  } else if (eligibility_status === 'Under Review') {
    classOfBtn = classes.medium;
  }

  if (status === 'Completed') {
    classOfBtn = classes.normal;
  } else if (status === 'Pending') {
    classOfBtn = classes.error;
  }

  if (document_submitted === 'Submitted') {
    classOfBtn = classes.normal;
  } else if (document_submitted === 'Not Submitted') {
    classOfBtn = classes.error;
  }
  // const classes = useStyles();

  return columns.map((ele) => {
    if (ele.inline_edit_type == 'kenDatePicker') {
      console.log('rating', ele);
      return (
        <TableCell align="left">
          {isEditMode ? (
            <KenDateTimePicker
              name={ele.column_name}
              label={ele.label}
              placeholder="Start Date"
              value={row[ele.column_name]}
              type="date"
              required={true}
              onChange={(e) => onChange(e, row)}
            />
          ) : (
            row[ele.column_name]
          )}
        </TableCell>
      );
    } else if (ele.inline_edit_type === 'kenTime') {
      if (isEditMode) {
        if (ele.column_name === 'start_time') {
          const start_time = moment(row[ele.column_name], ['h:mm A']).format(
            'HH:mm'
          );

          row[ele.column_name] = start_time;
        }
        if (ele.column_name === 'end_time') {
          const end_time = moment(row[ele.column_name], ['h:mm A']).format(
            'HH:mm'
          );
          row[ele.column_name] = end_time;
        }
      }
      return (
        <TableCell align="left">
          {isEditMode ? (
            <>
              <KenDateTimePicker
                name={ele.column_name}
                label={ele.label}
                placeholder={ele.label}
                value={row[ele.column_name]}
                type="time"
                required={true}
                onChange={(e) => onChange(e, row)}
              />
            </>
          ) : (
            row[ele.column_name]
          )}
        </TableCell>
      );
    } else if (ele.inline_edit_type == 'kenSelect') {
      return (
        <TableCell align="left">
          {isEditMode ? (
            <Box>
              <KenSelect
                name={ele.column_name}
                options={ele.dropdown}
                value={row[ele.column_name]}
                dropdownColor="#ffffff"
                onChange={(e) => onChange(e, row)}
                required={true}
                label={ele.label}
              />
            </Box>
          ) : (
            <Button
              variant="primary"
              // component={Link}
              className={classOfBtn}
              // to={`${routes.invigilationProctoring}/${id}`}
            >
              {row[ele.column_name]}{' '}
            </Button>
          )}
        </TableCell>
      );
    } else if (ele.inline_edit_type == 'kenInput') {
      return (
        <TableCell align="left">
          {isEditMode ? (
            <Input
              value={row[ele.column_name]}
              name={ele.column_name}
              onChange={(e) => onChange(e, row)}
            />
          ) : (
            row[ele.column_name]
          )}
        </TableCell>
      );
    } else {
      return <TableCell>{row[ele.column_name]}</TableCell>;
    }
  });
};

export default KenGridEditableData;
